import { useReveal } from "@/hooks/useReveal";

const ITEMS = [
  {
    icon: "ri-bar-chart-2-line",
    title: "Batch-to-batch consistency, documented",
    body: "Every run leaves with a certificate of analysis. Granulometry, moisture and polarisation are held to an agreed specification, not to whatever the batch produced.",
  },
  {
    icon: "ri-clipboard-line",
    title: "Ready for a supplier audit",
    body: "HACCP, INVIMA registration and an annual Ecocert audit. We can supply the supplier questionnaire pack, process flow diagrams and traceability records before you schedule a visit.",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "Labelling adapted to your market",
    body: "We produce the pack to your destination market's labelling rules, with the local importer's details, allergen declaration, metric net quantity and date format agreed in writing before the run.",
  },
  {
    icon: "ri-grid-line",
    title: "A category, not a single line",
    body: "Cane sugar in several formats and cocoa powder can come from the same production run and consolidate into one container, which keeps your landed cost per unit down across the range.",
  },
];

export default function OwnBrand() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="own-brand" className="bg-cream py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal max-w-2xl">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            For own brand and category buyers
          </h2>
          <p className="mt-4 text-ink/70 text-lg leading-relaxed">
            You are not looking for an interesting supplier. You are looking
            for one who will not become a problem at audit, at labelling
            review, or three months into a listing. Everything below is written
            for that.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {ITEMS.map((item) => (
            <div
              key={item.title}
              className="bg-white rounded-lg p-7 border border-cream-dark/60"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-cream text-brown">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 text-ink font-serif text-lg md:text-xl font-semibold">
                {item.title}
              </h3>
              <p className="mt-2 text-ink/70 text-[17px] leading-relaxed">
                {item.body}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 border border-brown/30 rounded-lg bg-white px-6 py-5">
          <p className="text-ink/80 text-[17px] leading-relaxed">
            We understand listing windows are annual and coding cycles are
            long. Tell us your window and we will work backwards from it.
          </p>
        </div>

        <div className="mt-8">
          <a
            href="#quote"
            className="inline-flex items-center gap-2 text-brand font-semibold text-base hover:underline"
          >
            Request a private label proposal
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}